import { cloneTr } from './clone-tr';

// Returns a new transaction that removes a table node if the cursor is inside of it.
export var removeTable = function removeTable(tr) {
  var $from = tr.selection.$from;
  for (var depth = $from.depth; depth > 0; depth--) {
    var node = $from.node(depth);
    if (node.type.spec.tableRole === 'table') {
      return cloneTr(tr.delete($from.before(depth), $from.after(depth)));
    }
  }
  return tr;
};